module.exports = __webpack_public_path__ + "img/chara_7.75544a44.png";